import { format } from "date-fns";
import { useCallback, useMemo, useRef } from "react";
const useCalendarMobileModal = (props)=>{
    const { visible , confirm , onChange: propsOnChange , minTime ='00:00' , maxTime ='23:59' , mode ='single' , enableTime =false , minDate  } = props;
    const containerRef = useRef(null);
    const finalMinDate = useMemo(()=>{
        if (!minDate) return undefined;
        if (minDate === 'today') return new Date();
        if (minDate instanceof Date) return minDate;
        return new Date(minDate);
    }, [
        minDate
    ]);
    const updateWeekdaysPosition = useCallback(()=>{
        if (!containerRef.current) return;
        const wrapper = containerRef.current.querySelector('.flatpickr-wrapper');
        const weekdays = containerRef.current.querySelector('.flatpickr-weekdays');
        if (!wrapper || !weekdays) return;
        const wrapperTop = wrapper.offsetTop;
        weekdays.style.top = `${wrapperTop}px`;
    }, []);
    const updateMonthsPosition = useCallback((self)=>{
        if (!containerRef.current) return;
        const currDate = finalMinDate ?? new Date();
        self.changeMonth(currDate.getMonth(), false);
        self.changeYear(currDate.getFullYear());
        const months = containerRef.current.querySelectorAll('.flatpickr-month');
        const dayContainers = containerRef.current.querySelectorAll('.dayContainer');
        const days = containerRef.current.querySelector('.flatpickr-days');
        if (!days) return;
        const daysTop = days.offsetTop;
        for(let i = 0, length = months.length; i < length; i++){
            const month = months[i];
            const dayContainer = dayContainers[i];
            if (!month || !dayContainer) continue;
            const dayContainerTop = dayContainer.offsetTop;
            const monthHeight = month.offsetHeight;
            month.style.top = `${daysTop + dayContainerTop - monthHeight}px`;
        }
    }, [
        finalMinDate
    ]);
    const updateScrollPosition = useCallback((self)=>{
        if (!containerRef.current) return;
        const selectedDate = self.selectedDates[0];
        if (!selectedDate) return;
        const selectedMonth = selectedDate.getMonth();
        const selectedYear = selectedDate.getFullYear();
        const offsetYears = selectedYear - self.currentYear;
        const offsetYearsIndex = offsetYears * 12;
        const targetMonthIndex = selectedMonth - self.currentMonth + offsetYearsIndex;
        const months = containerRef.current.querySelectorAll('.flatpickr-month');
        const month = months[targetMonthIndex];
        const monthTop = parseInt(month.style.top.replace('px', ''));
        const weekdays = containerRef.current.querySelector('.flatpickr-weekdays');
        const weekdaysHeight = weekdays?.offsetHeight ?? 0;
        containerRef.current.scroll?.({
            top: monthTop - weekdaysHeight,
            behavior: 'smooth'
        });
    }, []);
    const onReady = useCallback((_dates, _currentDateString, self)=>{
        requestAnimationFrame(()=>{
            if (visible) {
                updateMonthsPosition(self);
                updateWeekdaysPosition();
                updateScrollPosition(self);
            }
        });
    }, [
        updateMonthsPosition,
        updateScrollPosition,
        updateWeekdaysPosition,
        visible
    ]);
    const onChange = useCallback((dates)=>{
        const finalDates = [
            ...dates
        ];
        for (const [index, date] of dates.entries()){
            const dateTime = format(date, 'HH:mm');
            if (dateTime <= minTime) {
                const [hours, minutes] = minTime.split(':');
                finalDates[index] = new Date(date.getFullYear(), date.getMonth(), date.getDate(), parseInt(hours), parseInt(minutes));
            } else if (dateTime >= maxTime) {
                const [hours, minutes] = maxTime.split(':');
                finalDates[index] = new Date(date.getFullYear(), date.getMonth(), date.getDate(), parseInt(hours), parseInt(minutes));
            }
        }
        propsOnChange?.(finalDates);
        if (mode === 'single' && !enableTime) {
            confirm();
        }
    }, [
        confirm,
        enableTime,
        maxTime,
        minTime,
        mode,
        propsOnChange
    ]);
    return {
        containerRef,
        onReady,
        onChange
    };
};
export default useCalendarMobileModal;

//# sourceMappingURL=useCalendarMobileModal.js.map